import React, { useEffect, useState } from "react";
import EducationTop from "./EducationTop";
import tick from "../../Assets/svg/green-bg-tick.svg";
import "./education.scss";
import EducationBtm from "./EducationBtm";
import { useDispatch, useSelector } from "react-redux";
import { addEduTotal } from "./redux/actions";
import ModalComponent from "../modules/Modal";
import Button from "../modules/Button";
function EducationDetails() {
  const dispatch = useDispatch();
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });

  const eduInfo = useSelector((state) => state.education);
  useEffect(() => {
    // console.log("eduInfo", eduInfo);
    let edu = eduInfo.eduInfo;
    let total = 0;
    let count = 0;
    for (let i in edu) {
      total += 1;
      if (edu[i]) {
        count += 1;
      }
    }
    // dispatch(addEduTotal(total));

    // console.log('in main',  total,count)
  }, [eduInfo]);
  return (
    <div className="education-page">
      <EducationTop />
      <EducationBtm
        showModal={(e) => showModal({ ...isModal, show: true, msg: e })}
      />
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been uploaded successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
            {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>

          {/* <div className="modal-btn-set">
              <Button
                onClickHandler={() => CancelData()}
                type={"contained override"}
                value={"No"}
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={ModalData.type === "confirm" ? "Yes, Submit" :ModalData.type === "cancel" ?"Yes": "Okay"}
              />
            </div> */}
        </ModalComponent>
      )}
    </div>
  );
}

export default EducationDetails;
